import { __extends } from "tslib";
import { Plot } from '../../core/plot';
import { deepAssign } from '../../utils';
import { adaptor } from './adaptor'; // registered shapes

import './shapes/circle';
import './shapes/square';

var Heatmap =
/** @class */
function (_super) {
  __extends(Heatmap, _super);

  function Heatmap() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'heatmap';
    return _this;
  }
  /**
   * 获取直方图的适配器
   */


  Heatmap.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  Heatmap.prototype.getDefaultOptions = function () {
    return deepAssign({}, _super.prototype.getDefaultOptions.call(this), {
      type: 'polygon',
      legend: false,
      xAxis: {
        tickLine: null,
        line: null,
        grid: {
          alignTick: false,
          line: {
            style: {
              lineWidth: 1,
              lineDash: null,
              stroke: '#f0f0f0'
            }
          }
        }
      },
      yAxis: {
        grid: {
          alignTick: false,
          line: {
            style: {
              lineWidth: 1,
              lineDash: null,
              stroke: '#f0f0f0'
            }
          }
        }
      }
    });
  };

  return Heatmap;
}(Plot);

export { Heatmap };